export default __webpack_public_path__ + "c570ff288199707d6f87f5eafec0818b.png";